import CheckBox from './CheckBox';

export default CheckBox;